import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaEdit, FaGift, FaPrint, FaTrash, FaSearch, FaSync, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import PrintSaleInvoice from '../Store/PrintSaleInvoice';
import Puff from 'react-loading-icons/dist/esm/components/puff';
import Pusher from 'pusher-js';
import { Alert } from '@mui/material';
import { toast } from 'react-toastify';
import { useStateContext } from '../Context/ContextProvider';

function AllSaleInvoices() {
  const [invoiceList, setInvoiceList] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [printData, setPrintData] = useState([]);
  const [isPrint, setIsPrint] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const [norecord, setNoRecord] = useState(false);
 const{type}= useStateContext();
  // Pusher connection for real-time invoices
  useEffect(() => {
    const pusher = new Pusher('645b9acd1b4a187e96c6', {
      cluster: 'ap2',
    });

    const channel = pusher.subscribe('sendInvoiceNoChenel');
    channel.bind('sendInvoiceNoEvent', (data) => {
      const object = {
        'invoiceno': data.invoiceNo,
        'name': data.name
      };
      setInvoiceList(prevInvoiceList => [...prevInvoiceList, object]);
    });

    return () => {
      channel.unbind();
      channel.unsubscribe();
    };
  }, []);

  // Fetch invoices on page/search change
  useEffect(() => {
    axios.get(`/api/allsaleinvoices?page=${currentPage}&search=${searchQuery}`).then(response => {
      setInvoices(response.data.invoices.data);
      setTotalPages(response.data.invoices.last_page);
      setItemsPerPage(response.data.invoices.per_page);
      setNoRecord(response.data.invoices.data.length === 0);
    });
  }, [currentPage, searchQuery]);

  // Handle invoice deletion
  const handleDelInvoice = (id, index) => {
    setLoadingStates(prev => ({ ...prev, [index]: 'delete' }));
    const data = { 'id': id };

    axios.post(`api/delete/invoice`, data).then(res => {
      if (res.data.msg === '0') {
        toast.warning('Day Has Been Closed!', {
          position: "top-right",
          autoClose: 2000,
          theme: "light",
        });
      } else if (res.data.status === 200) {
        toast.error('Invoice Deleted!', {
          position: "top-right",
          autoClose: 2000,
          theme: "light",
        });
        handleDeletedReInvoice(data.id, index);
      }
      setLoadingStates(prev => ({ ...prev, [index]: null }));
    });
  };

  // Handle deleted re-invoice print
  const handleDeletedReInvoice = (id, index) => {
    setLoadingStates(prev => ({ ...prev, [index]: 'print' }));
    const data = { 'id': id };

    axios.get('/sanctum/csrf-cookie').then(() => {
      axios.post('/api/deletedreinvoice/print', data).then(res => {
        const printDatas = {
          letter: res.data.cart,
          dates: res.data.dates,
          salestax: res.data.salestax,
          shipping: res.data.shipping,
          discount: res.data.discount,
          grandtotal: res.data.grandtotal,
          invoiceno: res.data.invoiceno,
          remainingbill: res.data.remainingbill,
          customer: res.data.customer,
          customeraddress: res.data.customeraddress,
          salesman: res.data.salesman,
          payment: res.data.payment,
          totalpay: res.data.totalpay,
          pbalance: res.data.pbalance,
          recovery: res.data.recovery,
          printingtime: res.data.printingtime,
          manualdate: res.data.manualdate,
          detail: res.data.detail,
          imagesrc: res.data.detail,
          entercash: res.data.entercash,
          paymentType: res.data.payment_type,
          mesg: res.data.status,
          isGift: 'No'
        };
        setPrintData(printDatas);
        setIsPrint(true);
        setLoadingStates(prev => ({ ...prev, [index]: null }));
      });
    });
  };

  // Handle re-invoice print
  const handleReInvoice = (e, id, index, isGift = 'No') => {
    e.preventDefault();
    setLoadingStates(prev => ({ ...prev, [index]: isGift === 'Yes' ? 'gift' : 'print' }));
    const data = { 'id': id };

    axios.get('/sanctum/csrf-cookie').then(() => {
      axios.post('/api/reinvoice/print', data).then(res => {
        const printDatas = {
          letter: res.data.cart,
          dates: res.data.dates,
          salestax: res.data.salestax,
          shipping: res.data.shipping,
          discount: res.data.discount,
          grandtotal: res.data.grandtotal,
          invoiceno: res.data.invoiceno,
          remainingbill: res.data.remainingbill,
          customer: res.data.customer,
          customeraddress: res.data.customeraddress,
          salesman: res.data.salesman,
          payment: res.data.payment,
          totalpay: res.data.totalpay,
          pbalance: res.data.pbalance,
          recovery: res.data.recovery,
          printingtime: res.data.printingtime,
          manualdate: res.data.manualdate,
          detail: res.data.detail,
          imagesrc: res.data.detail,
          entercash: res.data.entercash,
          isGift: isGift
        };
        setPrintData(printDatas);
        setIsPrint(true);
        setLoadingStates(prev => ({ ...prev, [index]: null }));
      });
    });
  };

  // Handle print
  useEffect(() => {
    if (isPrint) {
      const div = document.getElementById('printablearea');
      const win = window.open('', '', 'height=700,width=700');
      win.document.write(div.outerHTML);
      win.document.close();
      setTimeout(() => {
        win.print();
        win.close();
      }, 1000);
      setIsPrint(false);
    }
  }, [isPrint]);

  // Get serial number
  const getSerialNumber = (index) => {
    return (currentPage - 1) * itemsPerPage + index + 1;
  };

  return (
    <div className="invoices-container">
      <div className="invoices-header">
        <h1 className="page-title">All Sale Invoices</h1>
        <div className="header-underline"></div>
      </div>

      <div className="search-section">
        <div className="search-wrapper">
          <FaSearch className="search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Search by customer name, invoice number or salesman..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        {norecord && <div className="no-record">No matching records found</div>}
      </div>

      <div className="table-wrapper">
        <Table className="modern-table" hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Customer Name</th>
              <th>Salesman</th>
              <th>Invoice No</th>
              <th>Total Amount</th>
              <th>Cash Received</th>
              <th>Cash Taken</th>
              <th>Cash Return</th>
              <th>Discount</th>
              <th>Net Due</th>
              <th>Date</th>
              <th>Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {invoices.length === 0 && !norecord ? (
              <tr>
                <td colSpan="13" className="loading-cell">
                  <Puff stroke="#667eea" />
                  <span>Loading invoices...</span>
                </td>
              </tr>
            ) : (
              invoices.map((item, index) => (
                <tr key={item.id} className={item.qty < 15 ? 'low-stock-row' : ''}>
                  <td className="serial">{getSerialNumber(index)}</td>
                  <td className="customer-name">{item.name}</td>
                  <td>{item.salesman}</td>
                  <td className="invoice-no">{item.visitor_id}</td>
                  <td className="amount">{parseFloat(item.total).toFixed(2)}</td>
                  <td>{parseFloat(item.cash_received).toFixed(2)}</td>
                  <td>{parseFloat(item.entercash).toFixed(2)}</td>
                  <td>{parseFloat(item.entercash - item.cash_received).toFixed(2)}</td>
                  <td>{parseFloat(item.discount).toFixed(2)}</td>
                  <td className={item.due_amount > 0 ? 'due-amount' : ''}>
                    {parseFloat(item.due_amount).toFixed(2)}
                  </td>
                  <td>{item.invoice_date}</td>
                  <td>
                    <span className={`type-badge ${item.type === 'Credit' ? 'type-credit' : 'type-cash'}`}>
                      {item.type}
                    </span>
                  </td>
                  <td className="actions-cell">
                    <button
                      onClick={() => handleDelInvoice(item.visitor_id, index)}
                      className="action-btn delete-btn"
                      disabled={loadingStates[index] === 'delete'}
                      title="Delete Invoice"
                    >
                      {loadingStates[index] === 'delete' ? <Puff width={14} height={14} /> : <FaTrash />}
                    </button>
                    <Link
                      target="_blank"
                      className="action-btn edit-btn"
                      to={`/editsaleinvoice/${item.visitor_id}`}
                      title="Edit Invoice"
                    >
                      <FaEdit />
                    </Link>
                    <button
                      onClick={(e) => handleReInvoice(e, item.visitor_id, index, 'No')}
                      className="action-btn print-btn"
                      disabled={loadingStates[index] === 'print'}
                      title="Print Invoice"
                    >
                      {loadingStates[index] === 'print' ? <Puff width={14} height={14} /> : <FaPrint />}
                    </button>
                
                    <button
                      onClick={(e) => handleReInvoice(e, item.visitor_id, index, 'Yes')}
                      className="action-btn gift-btn"
                      disabled={type!=='Managment'?true:false}
                      title="Print Gift Invoice"
                    >
                      {loadingStates[index] === 'gift' ? <Puff width={14} height={14} /> : <FaGift />}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      {totalPages > 1 && (
        <div className="pagination-section">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(page => page - 1)}
            className="pagination-btn prev"
          >
            <FaChevronLeft /> Previous
          </button>
          <span className="page-info">
            Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
          </span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(page => page + 1)}
            className="pagination-btn next"
          >
            Next <FaChevronRight />
          </button>
        </div>
      )}

      <div className="sidebar-panel">
        <div className="sidebar-header">
          <h5>Fresh Invoice List</h5>
          <FaSync className="sync-icon" />
        </div>
        <div className="sidebar-list">
          {invoiceList.slice().reverse().map((item, idx) => (
            <div key={item.invoiceno} className="invoice-alert">
              <Alert severity="info" className="custom-alert">
                <p className="invoice-number" title={item.name}>
                  Invoice #{item.invoiceno}
                </p>
                <div className="alert-actions">
                  <button
                    onClick={(e) => handleReInvoice(e, item.invoiceno, `sidebar_${idx}`, 'No')}
                    className="alert-btn print"
                    title="Print Invoice"
                  >
                    <FaPrint />
                  </button>
                  <Link
                    target="_blank"
                    className="alert-btn edit"
                    to={`/editsaleinvoice/${item.invoiceno}`}
                    title="Edit Invoice"
                  >
                    <FaEdit />
                  </Link>
                </div>
              </Alert>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'none' }}>
        {isPrint && <PrintSaleInvoice data={printData} />}
      </div>

      <style>{`
        .invoices-container {
          min-height: 100vh;
          background: linear-gradient(145deg, #f8f9fc 0%, #eef2f7 100%);
          padding: 25px 30px;
          position: relative;
        }
        
        .invoices-header {
          margin-bottom: 25px;
        }
        
        .page-title {
          font-size: 24px;
          font-weight: 700;
          color: #1e3c72;
          margin: 0 0 10px 0;
        }
        
        .header-underline {
          width: 60px;
          height: 4px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 2px;
        }
        
        .search-section {
          margin-bottom: 25px;
        }
        
        .search-wrapper {
          position: relative;
          max-width: 400px;
        }
        
        .search-icon {
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
          color: #999;
          font-size: 16px;
        }
        
        .search-input {
          width: 100%;
          padding: 12px 15px 12px 45px;
          border: 1.5px solid #e0e0e0;
          border-radius: 12px;
          font-size: 14px;
          transition: all 0.3s ease;
          background: white;
        }
        
        .search-input:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102,126,234,0.1);
        }
        
        .no-record {
          margin-top: 10px;
          color: #ff9800;
          font-size: 14px;
        }
        
        .table-wrapper {
          background: white;
          border-radius: 16px;
          padding: 20px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.08);
          overflow-x: auto;
          margin-bottom: 25px;
        }
        
        .modern-table {
          width: 100%;
          border-collapse: collapse;
          min-width: 1200px;
        }
        
        .modern-table th {
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          color: white;
          padding: 14px 12px;
          font-size: 13px;
          font-weight: 600;
          white-space: nowrap;
        }
        
        .modern-table td {
          padding: 12px;
          border-bottom: 1px solid #f0f0f0;
          font-size: 13px;
          color: #555;
        }
        
        .modern-table tr:hover td {
          background: #f8f9fc;
        }
        
        .low-stock-row td {
          background: #fff3e0;
        }
        
        .serial {
          font-weight: 600;
          color: #667eea;
        }
        
        .customer-name {
          font-weight: 500;
          color: #333;
        }
        
        .invoice-no {
          font-family: monospace;
          font-weight: 600;
          color: #1e3c72;
        }
        
        .amount {
          font-weight: 600;
          color: #28a745;
        }
        
        .due-amount {
          color: #dc3545;
          font-weight: 600;
        }
        
        .type-badge {
          display: inline-block;
          padding: 4px 10px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
        }
        
        .type-cash {
          background: #e8f5e9;
          color: #4caf50;
        }
        
        .type-credit {
          background: #fff3e0;
          color: #ff9800;
        }
        
        .actions-cell {
          display: flex;
          gap: 6px;
          flex-wrap: nowrap;
          white-space: nowrap;
        }
        
        .action-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          text-decoration: none;
          font-size: 12px;
        }
        
        .delete-btn {
          background: #fee2e2;
          color: #dc3545;
        }
        
        .delete-btn:hover:not(:disabled) {
          background: #dc3545;
          color: white;
          transform: translateY(-2px);
        }
        
        .edit-btn {
          background: #e3f2fd;
          color: #2196f3;
        }
        
        .edit-btn:hover {
          background: #2196f3;
          color: white;
          transform: translateY(-2px);
        }
        
        .print-btn {
          background: #e8f5e9;
          color: #4caf50;
        }
        
        .print-btn:hover:not(:disabled) {
          background: #4caf50;
          color: white;
          transform: translateY(-2px);
        }
        
        .gift-btn {
          background: #fff3e0;
          color: #ff9800;
        }
        
        .gift-btn:hover:not(:disabled) {
          background: #ff9800;
          color: white;
          transform: translateY(-2px);
        }
        
        .action-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        .loading-cell {
          text-align: center;
          padding: 50px !important;
        }
        
        .loading-cell span {
          display: block;
          margin-top: 10px;
          color: #999;
        }
        
        .pagination-section {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 20px;
          margin-top: 20px;
        }
        
        .pagination-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 20px;
          background: white;
          border: 1.5px solid #e0e0e0;
          border-radius: 10px;
          color: #1e3c72;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .pagination-btn:hover:not(:disabled) {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border-color: transparent;
          transform: translateY(-2px);
        }
        
        .pagination-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        .page-info {
          font-size: 14px;
          color: #666;
        }
        
        .sidebar-panel {
          position: fixed;
          right: 0;
          top: 0;
          width: 320px;
          height: 100vh;
          background: white;
          box-shadow: -4px 0 20px rgba(0,0,0,0.1);
          padding: 20px;
          overflow-y: auto;
          z-index: 1000;
          transform: translateX(100%);
          transition: transform 0.3s ease;
        }
        
        .sidebar-panel:hover {
          transform: translateX(0);
        }
        
        .sidebar-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 15px;
          border-bottom: 2px solid #f0f0f0;
          margin-bottom: 15px;
        }
        
        .sidebar-header h5 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #1e3c72;
        }
        
        .sync-icon {
          color: #667eea;
          font-size: 14px;
        }
        
        .sidebar-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        
        .invoice-alert {
          margin-bottom: 10px;
        }
        
        .custom-alert {
          padding: 12px !important;
        }
        
        .invoice-number {
          margin: 0 0 10px 0;
          font-weight: 600;
          cursor: pointer;
        }
        
        .alert-actions {
          display: flex;
          gap: 8px;
        }
        
        .alert-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          text-decoration: none;
          font-size: 12px;
        }
        
        .alert-btn.print {
          background: #4caf50;
          color: white;
        }
        
        .alert-btn.edit {
          background: #2196f3;
          color: white;
        }
        
        .alert-btn:hover {
          transform: scale(1.05);
        }
        
        @media (max-width: 1200px) {
          .sidebar-panel {
            transform: translateX(0);
            top: auto;
            bottom: 0;
            left: 0;
            width: 100%;
            height: auto;
            max-height: 300px;
            box-shadow: 0 -4px 20px rgba(0,0,0,0.1);
          }
          
          .sidebar-list {
            flex-direction: row;
            overflow-x: auto;
          }
          
          .invoice-alert {
            min-width: 250px;
          }
        }
        
        @media (max-width: 768px) {
          .invoices-container {
            padding: 15px;
          }
          
          .page-title {
            font-size: 20px;
          }
          
          .table-wrapper {
            padding: 15px;
          }
          
          .modern-table th,
          .modern-table td {
            padding: 10px 8px;
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
}

export default AllSaleInvoices;